import { z } from "zod";

export const desktopRuntimeContextSchema = z.object({
  appVersion: z.string().min(1),
  os: z.string().min(1),
  commandScope: z.literal("desktop:runtime_context"),
  webmcpEnabled: z.boolean(),
  windowLabel: z.literal("main")
});

export type DesktopRuntimeContext = z.infer<typeof desktopRuntimeContextSchema>;
